import { type CustomTooltipProps } from "ag-grid-react"
import { Cube, Equals, Tag } from "@phosphor-icons/react"

import HoverCardRow from "~/components/reusable/hovercard/HoverCardRow"
import { formatNumber } from "~/utils/formatting"
import {
  type InventoryCostTooltipValue,
  describeInventoryCost,
  formatCostPrice,
} from "~/utils/inventoryCalendar"

import HeaderTooltip from "./HeaderTooltip"

const PRICE_LABEL = { variant: "Avg. SKU cost price", sku: "SKU cost price" } as const

const InventoryCostTooltip = (props: CustomTooltipProps<unknown, InventoryCostTooltipValue>) => {
  if (props.location === "header") {
    return <HeaderTooltip {...props} />
  }
  const tooltip = props.value
  if (!tooltip) return null
  const { formula, note } = describeInventoryCost(tooltip)

  return (
    <div className="w-80 overflow-hidden rounded-md bg-base shadow-tooltip">
      <div className="px-4 py-3 border-b border-base">
        <span className="label-base text-fg-base">Inventory value</span>
        <div className="text-2xl font-semibold mt-1 text-fg-base">
          {formatNumber(tooltip.value, 0)}
        </div>
        {note && <p className="paragraph-sm text-fg-subtle mt-1">{note}</p>}
      </div>
      {tooltip.level !== "group" && (
        <div className="py-1">
          <HoverCardRow
            icon={<Cube />}
            label="Closing stock"
            value={formatNumber(tooltip.units, 1)}
          />
          <HoverCardRow
            icon={<Tag />}
            label={PRICE_LABEL[tooltip.level]}
            valueExtra={<span className="text-fg-subtle">×</span>}
            value={formatCostPrice(tooltip.costPrice)}
          />
          <hr className="mx-4 border-strong" />
          <HoverCardRow
            icon={<Equals />}
            label="Inventory value"
            value={formatNumber(tooltip.value, 0)}
          />
        </div>
      )}
      <div className="border-t border-base px-4 py-2 bg-subtle">
        <p className="paragraph-sm text-fg-muted font-mono">{formula}</p>
      </div>
    </div>
  )
}

export default InventoryCostTooltip
